import { ChangeDetectionStrategy, Component, HostListener, ViewChild } from '@angular/core';
import { WizAgGrid, WizBasePopUp, WizDatasource } from '@wizeoo/akm-component-lib';
import { GridOptions, ColDef } from 'ag-grid-community';
import { VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';

import { IWidget } from '../../../manager/widgets/i-widget';
import { WizColDef } from '../../../manager/workingdata/fei.engine';
import { Model } from '../../../model/model';
import { ConnectVO } from '../../../vo/core/connect.vo';
import { ConnectIconRenderer } from '../../../manager/core/connectrenderers/connect-icon.renderer';

/**
 * Pop de sélection des fonctions connect du widget
 */
@Component({
  templateUrl: './widget-display-connect.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetDisplayConnectPop extends WizBasePopUp {
  @ViewChild('agGrid') agGrid: WizAgGrid<ConnectVO>;

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.onSave();
    }
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  public static width: string = '600px';
  public static height: string = '450px';

  /** configuration de l'agGrid */
  gridOptions: GridOptions = { 
    suppressRowClickSelection: true, // pas de sélection directe, on gère nous même
  };

  // rendu petite boule pour les scenars
  public renderers: any = {  
    connectIconRenderer: ConnectIconRenderer,
  };

  public columns: ColDef[]; // Colonnes du grid
  

  /** la DS du grid */
  public connectDS: WizDatasource<ConnectVO> = new WizDatasource<ConnectVO>()
  .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
  .setSelectionMode('multiple')
  .build();

  private get widget(): IWidget {
    return this.datas;
  }

  private get model(): Model {
    return this.widget.model;
  }

  show(): void { 
    this.feedDatasources();
  }


  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    this.columns = this.buildColumns(); // générer les colonnes depuis le contexte
    
    const buCnx: Map<string, ConnectVO> =  this.model.connectMapExt?.get(this.model.domainCode)?.get( this.model.businessUnitCode);
    const cnxArr: ConnectVO[] = !!buCnx ? [...buCnx.values()] : [];
    this.connectDS.setSource(cnxArr); // alimentation de la liste principale

    let contextSel: Set<string> = new Set(this.widget.context.cnx || []);
    let selected: ConnectVO[] = [];
    this.connectDS.getWorkedSource().forEach(cnx => {
      if(contextSel.has(cnx.code)) {
        selected.push(cnx);
      }
    })
    this.connectDS.select(selected);


  }

  /** construction de la colonne */
  private buildColumns(): WizColDef[] {
    const result: WizColDef[] =  [
      {
        headerName: ' ',
        field: 'code',
        width: 40,
        cellRenderer: 'connectIconRenderer',
      },
      { headerName: '$.common.code.$', width: 80, sortable: true, field: 'code', tooltipField: 'code' },
      { headerName: '$.common.label.$', minWidth: 50, flex: 1, sortable: true,resizable: true, field: 'trsLabel', tooltipField: 'trsLabel' },   
    ];
    return result;
  }



  /** sur save, alimentation de l'objet de configuration */
  public onSave(): void {
    this.callback(this.connectDS.selectedItems);
    this.hide();
  }
}
